import ApiService from '@/services/api.service';

const TestOrderLocationsService = {
    getAllListing(parameters) {
        return ApiService.getWithArray('/PatientTestOrderLocations/', parameters);
    },

    add(data) {
        return ApiService.post(`/PatientTestOrderLocations`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientTestOrderLocations/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientTestOrderLocations/${id}`, data);
    },

    getLookup() {
        return ApiService.get('/PatientTestOrderLocations/LookUp');
    },

    Get(id){     
        return ApiService.get(`/PatientTestOrderLocations/${id}`);
    },
};

export default TestOrderLocationsService;
